import React from 'react'

const CorporateLogo1: React.FC = () => {
  return (
    <img style={{position: "relative", height: "100%", pointerEvents: "none", userSelect: "none"}} src="/svgs/corporate_logo1.svg" alt="corporate_logo1"/>
  )
}

export default CorporateLogo1